var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"splash-wrapper"}},[_c('div',{attrs:{"id":"splash-content"}},[_c('div',[_vm._v("OrbitCM App")]),_c('v-img',{attrs:{"src":require('@/assets/globe-computer.gif')}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }